import * as contextmenu from 'components/ContextMenu';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import FolderItemState from 'filestate/FolderItemState';
import preferences from 'Preferences';
import copyToClipboard from 'util/clipboard/copyToClipboard';

import {TestOrderListingGraphQL} from '../../../graphql-fragments/sample_tests/__generated/TestOrderListingGraphQL';

export function getContextMenuOptions(
  testOrder: TestOrderListingGraphQL
): Array<contextmenu.ContextMenuOption> {
  return [
    {
      name: 'Open',
      click: () => {
        FileBrowserActions.openFile(testOrder.sample.id, {
          onOpen: (fileState: FolderItemState) => {
            fileState.activateTestOrdersTab();
          },
        });
      },
    },
    {
      name: 'Copy API ID',
      click: () => {
        copyToClipboard(testOrder.id, {showToastOnSuccess: true});
      },
      hide: () => !preferences.get('ENABLE_COPY_API_ID'),
    },
  ];
}

export function open(e: Event, testOrder: TestOrderListingGraphQL): void {
  contextmenu.view.open(e, getContextMenuOptions(testOrder));
}
